(function() {
    'use strict';

    angular.module("montage")
        .controller('MontageProductUpdateController', MontageProductUpdateController);

    MontageProductUpdateController.$inject = ['montageProduct', '$uibModalInstance', 'notificationSrvc', 'montageProductDataSrvc', 'montageProductMessagesConst', 'errorNotificationSrvc'];

    function MontageProductUpdateController(montageProduct, $uibModalInstance, notificationSrvc, montageProductDataSrvc, montageProductMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            is_locked: [],
            locked_info: [],
            nonFieldErrors: []
        };
        self.montageProductData = montageProduct;

        self.updateMontageProduct = updateMontageProduct;
        self.close = close;
        self.cleanErrors = cleanErrors;

        function updateMontageProduct() {
            montageProductDataSrvc.update({
                pk: self.montageProductData.pk
            }, self.montageProductData).$promise.then(
                function(response) {
                    self.close();
                    notificationSrvc.notification("success", montageProductMessagesConst.update);
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function close() {
            $uibModalInstance.close();
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
